import { render, staticRenderFns } from "./RequestResponseCard.vue?vue&type=template&id=7a874658&scoped=true&"
import script from "./RequestResponseCard.vue?vue&type=script&lang=js&"
export * from "./RequestResponseCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestResponseCard.vue?vue&type=style&index=0&id=7a874658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a874658",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CGrid: require('@chakra-ui/vue').CGrid, CBox: require('@chakra-ui/vue').CBox})
